import React, { useState, useEffect } from "react";
import {
  PatternlibDropdown,
  PatternlibOption,
} from "@liebherr/patternlib-react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

const priorityIds = [276, 756, 40, 250];

const prioritizeEntries = (dataArray, priorityIds) => {
  const priorityEntries = dataArray.filter((item) =>
    priorityIds.includes(item.id)
  );
  const nonPriorityEntries = dataArray.filter(
    (item) => !priorityIds.includes(item.id)
  );

  // Preserve the order of prioritized entries as in the original array
  const orderedPriorityEntries = priorityIds.map((id) =>
    priorityEntries.find((entry) => entry.id === id)
  );

  return [...orderedPriorityEntries, ...nonPriorityEntries];

  // Return a alphabetic sorted order of prioritized entries
  //return [...priorityEntries, ...nonPriorityEntries];
};

const FormDropdown = ({
  label,
  placeholder,
  name,
  initialValue,
  data,
  error,
  onChange,
  isCountry,
}) => {
  const [value, setValue] = useState(initialValue.toLowerCase());
  const [inputValue, setInputValue] = useState("");
  const [showAllData, setShowAllData] = useState(true);
  const [modifiedData, setModifiedData] = useState(data);

  useEffect(() => {
    setValue(initialValue.toLowerCase());
  }, [initialValue]);

  useEffect(() => {
    const prioritizedData = prioritizeEntries(data, priorityIds);
    setModifiedData(prioritizedData);
  }, [data]);

  useEffect(() => {
    if (value) {
      onChange(value);
    } else if (value === "" || value === null) {
      onChange("");
    }
  }, [value]);

  const onChangeListener = (event) => {
    const val = event.detail.value;
    if (val == null) {
      setValue("");
      setShowAllData(true);
    } else {
      const lowercaseValue = val.toLowerCase(); // Convert to lowercase for case-insensitive search
      setInputValue(lowercaseValue);
      setShowAllData(false); // Set showAllData to false when the user starts typing
    }
  };

  const createUniqueId = () => {
    const id = uuidv4();
    return id;
  };

  const onSelectListener = (event) => {
    if (event.detail.selected?.value !== undefined) {
      const selectedValue = event.detail.selected.value;
      setValue(selectedValue);
      setShowAllData(true);
    }
  };

  return (
    <div>
      <PatternlibDropdown
        label={label}
        placeholder={placeholder}
        name={name}
        onBlur={onSelectListener}
        onLhSelect={onSelectListener}
        onLhChange={onChangeListener}
        value={value}
        show-remove-icon="true"
        close-on-scroll="false"
        error-text={error}
        status={error !== null ? "error" : "default"}
      >
        {modifiedData
          .filter(
            (item) =>
              showAllData || item.name.toLowerCase().includes(inputValue)
          ) // Perform a case-insensitive search
          .map((item) => {
            const uniqueId = createUniqueId();
            return (
              <PatternlibOption
                value={isCountry ? item.alpha2 : item.value}
                key={uniqueId}
                label={item.name}
              ></PatternlibOption>
            );
          })}
      </PatternlibDropdown>
    </div>
  );
};

FormDropdown.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  selected: PropTypes.string,
  data: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isCountry: PropTypes.bool,
};

FormDropdown.defaultProps = {
  label: "Label",
  placeholder: "Placeholder text",
  error: null,
  isCountry: false,
};

export default FormDropdown;
